import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiVoiceGeneratorConfig } from '@/data/landingConfig/landingAiVoiceGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiVoiceGenerator } from './schemaObject';

interface Props {}
const AiVoiceGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiVoiceGenerator} />
			<LandingTemplate
				data={landingAiVoiceGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVoiceGenerator()}
			/>
		</>
	);
};

export default AiVoiceGenerator;
